export default "__VITE_ASSET__BCLzEivD__"